import React from 'react';
import ChatScreen from '@/components/chat/ChatScreen';
import { useParams } from 'react-router-dom';
import ChatAccessGate from '@/components/chat/ChatAccessGate';

const ChatConversation = () => {
  const { username } = useParams<{ username: string }>();

  if (!username) {
    return null;
  }

  return (
    <ChatAccessGate options={{ context: 'conversation', targetUsername: username }}>
      <ChatScreen />
    </ChatAccessGate>
  );
};

export default ChatConversation;
